import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { OrganizationContext } from '../../../Services/OrganizationContext';
import authService from '../../../Services/authService';
import Breadcrumb from '../Breadcrumb/Breadcrumb';

const AddUser = () => {
  const navigate = useNavigate();
  const { organization } = useContext(OrganizationContext);
  const [role, setRole] = useState([]);
  const [formErrors, setFormErrors] = useState({});

  const [formData, setFormData] = useState({
    role_id: '',
    user_name: '',
    email: '',
    phone_number: '',
    is_active: false,
    employee_id: '',
  });

  useEffect(() => {
    if (organization) {
      loadRoles();
    }
  }, [organization]);

  const loadRoles = () => {
    const token = authService.getCurrentadmin().token;
    const url = new URL(authService.getApiUrl() + 'roles');
    url.searchParams.append('organization_id', organization);

    fetch(url, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json; charset=UTF-8',
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => res.json())
      .then((result) => setRole(result.data))
      .catch((err) => console.log(err.message));
  };

  const handleInputChange = (event) => {
    const { name, value, type, checked } = event.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value,
    });
  };

  const validateForm = () => {
    const errors = {};

    if (!formData.user_name.trim()) {
      errors.user_name = 'Name is required';
    } else if (!/^[a-zA-Z\s]+$/.test(formData.user_name)) {
      errors.user_name = 'Name field should contain letters only (no numbers or special characters)';
    }

    if (!formData.role_id) {
      errors.role_id = 'User Role is required';
    }

    if (!formData.phone_number.trim()) {
      errors.phone_number = 'Phone number is required';
    } else if (!/^[6-9]\d{9}$/.test(formData.phone_number)) {
      errors.phone_number = 'Phone number must be 10 digits and start with 6, 7, 8, or 9';
    }

    if (formData.email && !/^\S+@\S+\.\S+$/.test(formData.email)) {
      errors.email = 'Invalid email address';
    }

    if (!formData.employee_id.trim()) {
      errors.employee_id = 'Employee ID is required';
    }

    return errors;
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const errors = validateForm();
    setFormErrors(errors);
    if (Object.keys(errors).length > 0) return;

    const token = authService.getCurrentadmin().token;

    fetch(authService.getApiUrl() + 'user', {
      method: 'POST',
      body: JSON.stringify({
        user_name: formData.user_name,
        role_id: formData.role_id,
        phone_number: formData.phone_number,
        employee_id: formData.employee_id,
        email: formData.email,
        is_active: formData.is_active ? '1' : '0',
        organization_id: organization,
        organizations: '',
      }),
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json; charset=UTF-8',
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => res.json())
      .then((result) => {
        console.log(result.data);
        window.history.back();
      })
      .catch((err) => console.log(err.message));
  };

  return (
    <div className="main-container">
      <div className="container-fluid">
        <Breadcrumb />
        <div className="category-table user-add-cont">
          <div className="flex-cont add-cat">
            <div className="heading">
              <h3>Add User</h3>
            </div>
          </div>
          <form className="needs-validation clearfix" onSubmit={handleSubmit}>
            <div className="card">
              <div className="card-body custom-edit-service">
                <div className="addtest-fields mb-3">
                  <div className="flex-cont">
                    <div className="half-cont">
                      <div className="form-group">
                        <label>
                          Name <span className="text-danger">*</span>
                        </label>
                        <input
                          className={`form-control ${formErrors.user_name ? 'is-invalid' : ''}`}
                          type="text"
                          name="user_name"
                          value={formData.user_name}
                          onChange={handleInputChange}
                        />
                        {formErrors.user_name && <div className="errors">{formErrors.user_name}</div>}
                      </div>
                    </div>
                    <div className="half-cont">
                      <div className="form-group">
                        <label>
                          User Role <span className="text-danger">*</span>
                        </label>
                        <select
                          className={`form-select form-control ${formErrors.role_id ? 'is-invalid' : ''}`}
                          name="role_id"
                          value={formData.role_id}
                          onChange={handleInputChange}
                        >
                          <option value="">--Select--</option>
                          {role.map((item) => (
                            <option key={item.id} value={item.id}>{item.name}</option>
                          ))}
                        </select>
                        {formErrors.role_id && <div className="errors">{formErrors.role_id}</div>}
                      </div>
                    </div>
                    <div className="half-cont">
                      <div className="form-group">
                        <label>Email</label>
                        <input
                          className={`form-control ${formErrors.email ? 'is-invalid' : ''}`}
                          type="text"
                          name="email"
                          value={formData.email}
                          onChange={handleInputChange}
                        />
                        {formErrors.email && <div className="errors">{formErrors.email}</div>}
                      </div>
                    </div>
                    <div className="half-cont">
                      <div className="form-group">
                        <label>
                          Phone <span className="text-danger">*</span>
                        </label>
                        <input
                          className={`form-control ${formErrors.phone_number ? 'is-invalid' : ''}`}
                          type="text"
                          name="phone_number"
                          value={formData.phone_number}
                          onChange={handleInputChange}
                        />
                        {formErrors.phone_number && <div className="errors">{formErrors.phone_number}</div>}
                      </div>
                    </div>
                    <div className="half-cont">
                      <div className="form-group">
                        <label>
                          Employee ID <span className="text-danger">*</span>
                        </label>
                        <input
                          className={`form-control ${formErrors.employee_id ? 'is-invalid' : ''}`}
                          type="text"
                          name="employee_id"
                          value={formData.employee_id}
                          onChange={handleInputChange}
                        />
                        {formErrors.employee_id && <div className="errors">{formErrors.employee_id}</div>}
                      </div>
                    </div>
                    <div className="full-cont special-case-cont">
                      <div className="form-group">
                        <label className="custom-checkbox">
                          <input
                            type="checkbox"
                            name="is_active"
                            checked={formData.is_active}
                            onChange={handleInputChange}
                          />
                          <span className="checkmark"></span>
                          <label>Status</label>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="save-cont">
              <div className="right-cont">
                <button className="cancle-btn" type="button" onClick={() => window.history.back()}>Cancel</button>
                <button className="save-btn" type="submit">Save Changes</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddUser;
